<!-- BaseRadio.vue (admin) -->
<template tag="관리자 라디오 컴포넌트">
  <v-radio-group v-model="model" :inline="inline">
    <v-radio
      v-for="option in options"
      :key="option.value"
      :label="option.label"
      :value="option.value"
      class="mr-4"
      :disabled="disabled"
      :readonly="readonly"
    />
  </v-radio-group>
</template>
<script setup lang="ts">
import type { PropType } from "vue";
import type { CmmnCodeOptionType } from "@/types/cmmn/CmmnTypes";

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel<string | object>({ default: "" });

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
defineProps({
  disabled: Boolean, // 라디오 비활성화 여부
  options: { type: Array as PropType<CmmnCodeOptionType[]>, default: () => [] }, // 라디오 옵션
  inline: { type: Boolean, default: true }, // 라디오 인라인 여부
  readonly: { type: Boolean, default: false }, // 라디오 읽기 전용 여부
});
</script>
